define('lib/Podio.UI.Tasks.Create',['require','translate','underscore','jquery','lib/jquery/jquery.hotkeys','lib/Podio.UI.Tasks.Composer','lib/Podio.Transport.Tasks.Create','lib/Podio.UI.Modal','lib/Podio.UI','lib/Podio.Event.UI','lib/Podio.Event','lib/Podio.Utils','lib/Podio.Config','lib/Podio.UI.SettingsBalloon'],function (require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.hotkeys');

  var TasksComposer = require('lib/Podio.UI.Tasks.Composer');
  var TasksCreateTransport = require('lib/Podio.Transport.Tasks.Create');
  var modal = require('lib/Podio.UI.Modal');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var podioUtils = require('lib/Podio.Utils');
  var podioConfig = require('lib/Podio.Config');
  var settingsBalloon = require('lib/Podio.UI.SettingsBalloon');

  var onSuccessCallBack = {
    modal: null,
    page: null
  };
  var expandedTaskFormSetup = false;

  function newOnPage(options) {
    eventUI.unbind('submit', 'form#new_task');
    eventUI.bind('submit', 'form#new_task', TasksComposer.onTaskSubmit.curry(null, options.callback));
    TasksComposer.setupTaskForm($('#new_task_container form'));
    TasksComposer.focusTaskTextField();
  }

  function newModal(options) {
    options = options || {};
    onSuccessCallBack.modal = options.callback || function() {};
    eventUI.unbind('submit', 'form#new_task');
    eventUI.bind('submit', 'form#new_task', TasksComposer.onTaskSubmit.curry(onTaskSubmitted, null));
    var taskAttributes = options.attributes || {};
    var space_id = options.space_id;
    var variant = options.variant;
    var collapsed = options.collapsed;

    // If a reference was given, assume that it is on the current space if we are on a space
    if(_.isUndefined(space_id) && ! _.isUndefined(taskAttributes.ref_type)) {
      space_id = podioConfig.space_id;
    }

    var modalTitle = t('New Task #tasks');
    modal.showLoading(modalTitle);

    TasksCreateTransport.getCreateTaskModalLayout(taskAttributes, space_id, variant, collapsed, function(responseData) {
      showNewTaskModal(responseData, modalTitle);
    });
  }

  function showNewTaskModal(responseData, modalTitle) {
    if (podioUtils.isPresent(responseData.data.title_html)) {
      modalTitle = responseData.data.title_html;
    }

    modal.show(responseData.data.html, {title: modalTitle, width:770, hideOnOutsideClick: false});
    var elmForm = $('.modal-content form');
    TasksComposer.setupTaskForm(elmForm);
    TasksComposer.setupTaskFormExpanded(elmForm);
    TasksComposer.handleModalPlaceholders(elmForm);

    modal.signals.onModalClosed.addOnce(function () {
      settingsBalloon.hideAll();
    });
  }

  function onTaskTextKeyUp(elmTarget, e) {
    if (e.keyCode != keyCodes.Return) {
      if (elmTarget.val() === '') {
        $('#new_task_expand_on_type').addClass('hidden');
      } else {
        $('#new_task_expand_on_type').removeClass('hidden');
        if (! expandedTaskFormSetup) {
          TasksComposer.setupTaskFormExpanded($('#new_task_container form'));
          expandedTaskFormSetup = true;
        } else {
          TasksComposer.refreshUploader();
        }
      }
    }
  }

  function onCreateTaskHotkeyPressed(e) {
    if (!modal.isShowingModal()) {
      if ($('#wrapper').hasClass('tasks') && !$('#task-permalink').length && !$('.content-overlay').length) {
        // Put focus into create new task section on tasks page instead of showing modal
        e.preventDefault();
        TasksComposer.focusTaskTextField();

        $(window).scrollTop(0);
      } else {
        newContextAwareModal();
      }
    }
  }

  function newContextAwareModal(elmTarget, e) {
    var attributes = {};
    var space_navigation = $('#space-navigation');

    // Reference context
    var contextReference = getReferenceFromContext();
    if (contextReference) {
      attributes = $.extend(attributes, {
        ref_type: contextReference.type,
        ref_id: contextReference.id
      });
    } else if (space_navigation.length) {
      // If we are on a space without any specific task reference, reference the space
      attributes = $.extend(attributes, {
        ref_type: 'space',
        ref_id: space_navigation.data('space-id')
      });
    }

    // Due date and responsible
    if (elmTarget) {
      var contextObject = elmTarget.data('object');
      if (typeof(contextObject) === 'object') {
        if (contextObject.due) {
          attributes = $.extend(attributes, { due_date: contextObject.due });
        }
        if (contextObject.assign_to) {
          attributes = $.extend(attributes, { responsible: contextObject.assign_to });
        }
      }
    }

    newModal({'attributes': attributes});
  }

  function onTaskContextClicker(elmTarget) {
    var ref_type = elmTarget.data('ref_type');
    var ref_id = elmTarget.data('ref_id');
    var due_date = elmTarget.data('due_date');
    var responsible = elmTarget.data('responsible');

    // Take ref from context if not explicitly given
    if(!ref_type && !ref_id) {
      var contextReference = getReferenceFromContext();
      if (contextReference) {
        ref_type = contextReference.type;
        ref_id = contextReference.id;
      }
    }

    // Create new task modal and register callback function.
    newModal({
      attributes: {
        'ref_type': ref_type,
        'ref_id': ref_id,
        'due_date':due_date,
        'responsible':responsible
      }
    });
  }

  function onTaskReferenceRemoveClicked(elmTarget, e) {
    var elmModal = elmTarget.parents('.modal');
    var elmForm, elmRefId, elmSpaceRef, elmResponsibleTokenList;
    if (elmModal.length) {
      elmForm = elmModal.find('form#new_task');
    } else {
      elmForm = $('form#new_task');
    }
    elmForm.find('#task_ref_type').val('');
    elmForm.find('#task_ref_id').val('');
    elmModal.find('.modal-header h2').text(t('New task #tasks'));
    elmForm.find('.reference').remove();

    elmSpaceRef = elmForm.find('.space-reference');
    elmRefId = elmSpaceRef.find('#task_ref_id');
    elmRefId.val('');
    elmSpaceRef.find('#task_ref_type').val('space');
    elmSpaceRef.removeClass('hidden');

    // The responsible list might be disabled if reference does not allow assignment
    elmResponsibleTokenList = elmForm.find('.responsible-picker.disabled');
    elmResponsibleTokenList.removeClass('disabled tooltip');
  }

  function onTaskSubmitted(elmTarget) {
    // Show loading modal if we in a modal
    modal.showLoading(t('Creating Task ... #tasks'), { cancelable: true });

    // Send task to server
    TasksCreateTransport.createTask(elmTarget, function(responseData) {
      if (responseData.status === 'ok') {
        modal.hide();
        onSuccessCallBack.modal(responseData);
        podioEvent.trigger(podioEvent.Types.taskComplete, responseData);
      } else {
        modal.cancelLoading(t('New Task #tasks'));
        showTaskCreationError(responseData.message);

        // Restore button
        var elmSubmitButton = elmTarget.find('#task_submit');
        podioUI.restoreButtonWithLoader(elmSubmitButton);
      }
    });
  }

  function showTaskCreationError(message) {
    var elmModalContent = $('.modal .content .modal-wrapper .modal-content');
    if(elmModalContent.length) {
      var elmExistingError = elmModalContent.find('.error-failed');
      if(elmExistingError.length) {
        elmExistingError.html(message);
      } else {
        elmModalContent.prepend('<div class="error-failed">' + message + '</div>');
      }
    }
  }

  function getReferenceFromContext() {
    var supportedContexts = ['item', 'status', 'app', 'space', 'conversation'];
    if (podioUI && podioUI.context() &&
        _.include(supportedContexts, podioUI.context().context_type)) {
      return {
        type: podioUI.context().context_type,
        id: podioUI.context().context_id
      };
    }
  }

  function enableGlobalHotKey() {
    $(document).bind('keydown', 't', onCreateTaskHotkeyPressed);
  }

  function disableGlobalHotKey() {
    $(document).unbind('keydown');
  }

  function onDomReady() {
    if (podioUtils.loggedIn()) {
      // Global hotkey to create a new task
      enableGlobalHotKey();
    }

    eventUI.bind('keyup', '#new_task_container form #task_text', onTaskTextKeyUp);
    eventUI.bind('click', 'form#new_task .attach-file-to-task', TasksComposer.onAttachFileClicked);
    eventUI.bind('click', '.task-context-create', onTaskContextClicker);
    eventUI.bind('click', 'form#new_task div.reference span.close', onTaskReferenceRemoveClicked);

    // Create a task in context
    eventUI.bind('click', '.task-context-dialog-clicker', newContextAwareModal);
  }

  podioEvent.bind(podioEvent.Types.init, onDomReady);

  // Form events

  return {
    newOnPage: newOnPage,
    newModal: newModal,
    newContextAwareModal: newContextAwareModal,
    enableGlobalHotKey: enableGlobalHotKey,
    disableGlobalHotKey: disableGlobalHotKey
  };

});

